import { render, staticRenderFns } from "./FormsEnableModal.vue?vue&type=template&id=cbb3cce8&"
import script from "./FormsEnableModal.vue?vue&type=script&lang=js&"
export * from "./FormsEnableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports